<script setup>
import { VueFinalModal } from 'vue-final-modal';

defineProps({
  title: {
    type: String,
    default: undefined,
  },

  contentTransition: {
    type: String,
    default: 'fade',
  },
  headerMode: {
    type: Number,
    default: undefined,
  },
  headerColor: {
    type: String,
    default: 'white',
    validator: (value) => ['white', 'main'].includes(value),
  },
});
const emit = defineEmits(['transitionEnd', 'crossClick']);

function handleClose(close) {
  emit('crossClick');
  close();
}
</script>

<template>
  <VueFinalModal
    v-slot="{ close }"
    class="modal-fullscreen"
    overlay-class="modal-fullscreen__overlay"
    content-class="modal-fullscreen__content"
    :content-transition="contentTransition"
    :focus-trap="false"
    @transitionend="emit('transitionEnd')"
  >
    <ModalHeadersBase
      v-if="title"
      class="modal-fullscreen__header"
      :class="`modal-fullscreen__header--color--${headerColor}`"
      :title="title"
      :mode="headerMode"
      @close="handleClose(close)"
    >
      <slot name="header" />
    </ModalHeadersBase>

    <slot :close="close" />
  </VueFinalModal>
</template>

<style lang="scss">
.modal-fullscreen {
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @include media-breakpoint-down(sm) {
    bottom: unset;
    height: 100vh;
    height: 100dvh;
  }

  &__overlay {
    background-color: transparent;
  }

  &__content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding-bottom: 10dvh;
    margin-bottom: -10dvh;
  }

  &__header {
    &--color {
      &--white {
        background-color: $color-white;
      }

      &--main {
        background-color: $color-main-7;
      }
    }
  }
}
</style>
